export default __webpack_public_path__ + "static/media/thai-tea.887111c8.png";